import { Checkbox } from './Checkbox';

export type { TypeCheckBoxProps } from './types';
export default Checkbox;
